import { render } from "./Busin_nav.vue?vue&type=template&id=664e8020&scoped=true"
import script from "./Busin_nav.vue?vue&type=script&lang=js"
export * from "./Busin_nav.vue?vue&type=script&lang=js"

import "./Busin_nav.vue?vue&type=style&index=0&id=664e8020&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664e8020"]])

export default __exports__